export const MEMBER_STATUS = [
   { name: 'active', label: 'Active', class: '__green' },
   { name: 'overdue', label: 'Overdue', class: '__red' },
   { name: 'pending', label: 'Pending', class: '__orange' },
   { name: 'canceled', label: 'Canceled', class: '__grey' },
   { name: 'inactive', label: 'Inactive', class: '__red' }
]